module.exports = __webpack_public_path__ + "static/media/27_A.5d5c1a33.png";